<ng-container *ngIf="(recordingState$ | async) !== RECORDINGSTATEENUM.Error; else templateError">
   <span class="recording">
      <fa-icon
         class="text-danger-glow blink"
         [ngClass]="{
            'not-recording-icon': (recordingState$ | async) === RECORDINGSTATEENUM.NotRecording,
            'recording-icon': (recordingState$ | async) === RECORDINGSTATEENUM.Recording
         }"
         [icon]="recordingDot"
      ></fa-icon>
      <span>{{ 'samwin.recording_component.recording' | translate }}</span>
   </span>
</ng-container>

<ng-template #templateError>
   <span class="recording recording-error">
      <fa-icon class="error-recording-icon blink" [icon]="recordingExclamation"></fa-icon>
      <span>{{ 'samwin.recording_component.recording' | translate }}</span>
      <span>{{ 'samwin.recording_component.error' | translate }}</span>
      <fa-icon class="error-recording-icon right blink" [icon]="recordingExclamation"></fa-icon>
   </span>
</ng-template>
